import { render, staticRenderFns } from "./navoscotia.vue?vue&type=template&id=8777f680&"
import script from "./navoscotia.vue?vue&type=script&lang=js&"
export * from "./navoscotia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports